import ServerApi from './$server.api'

export default {
    getFixedprices,
    createFixedprice,
    updateFixedprice,
    deleteFixedprice
}

async function getFixedprices(query) {
    return await ServerApi.request('get', '/fixedprices', {query})
}

async function createFixedprice(data) {
    const timezone = new Date().getTimezoneOffset()/60
    const query = {timezone}
    return await ServerApi.request('post', '/fixedprices', {data, query})
}

async function updateFixedprice(fixedpriceId, data) {
    const timezone = new Date().getTimezoneOffset()/60
    const query = {timezone}
    return await ServerApi.request('put', `/fixedprices/${fixedpriceId}`, {data, query})
}

async function deleteFixedprice(fixedpriceId) {
    return await ServerApi.request('delete', `/fixedprices/${fixedpriceId}`)
}